<template>
  <v-card>
    <DateIntervalPicker
      v-model="interval"
      class="mb-3">
    </DateIntervalPicker>
    <v-card-title>{{ $t('pages.purchases.title') }}</v-card-title>
    <purchase-table
      :page="page"
      :period="interval"
      periodFilter="payed_at"
      withPriceInformations
      :scope="scope"
      @filterUpdated="data => onFilterUpdated(data)">
    </purchase-table>
  </v-card>
</template>

<script>
  import Utils from '@/utils/default'
  import withInterval from '@/mixins/withInterval'
  import PurchaseTable from '@/components/purchase/Table.vue'
  export default {
    components: {
      PurchaseTable
    },
    mixins: [withInterval],
    props: {
      page: {
        type: Number,
        default: 1
      }
    },
    computed: {
      scope () {
        return this.$route.params.scope || 'payed' // 'finished_with_cash_received_or_failed'
      }
    },
    methods: {
      onFilterUpdated (filter) {
        this.$router.push({
          ...this.$route,
          query: Utils.dataForUrl(filter)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Purchases.vue